module.exports = "/_next/static/images/PatternLightMobile-18df4963d9245389c66f79cd9da15a3c.png";